<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">销售订单</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="fromData"
        :noFromData="noFromData"
        :customerList="this.$store.state.cache.customerList"
        :companyList="this.$store.state.cache.companyList"
      ></v-head>
    </div>

    <div class="coll list_content">
      <h2 class="title">
        <span>数据明细</span>
      </h2>
      <v-list
        :fromData="fromData"
        :noFromData="noFromData"
        :factoryList="this.$store.state.cache.factoryList"
        ref="listChild"
      ></v-list>
    </div>

    <div class="coll list_content">
      <h2 class="title">
        <span>项目</span>
      </h2>
      <span>过量交货限度：</span>
      <el-input-number
        v-model="num1"
        style="margin-top:10px;width:100px"
        size="mini"
        controls-position="right"
        @change="handleChange"
        :min="0"
        :max="100"
      ></el-input-number>
      <span style="margin-left:10px">%</span>
      <el-checkbox v-model="checked" style="margin-left:30px">无限制</el-checkbox>
      <br />
      <span>交货不足限度：</span>
      <el-input-number
        v-model="num2"
        style="margin-top:10px;width:100px"
        size="mini"
        controls-position="right"
        @change="handleChange"
        :min="0.00"
        :max="100"
      ></el-input-number>
      <span style="margin-left:10px">%</span>
    </div>

    <div class="coll list_content">
      <h2 class="title">
        <span>备注文本</span>
      </h2>
      <el-input
        style="margin-top:10px"
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="fromData.projectShortTxt"
      ></el-input>
    </div>
  </div>
</template> 

<script>
import { customerApi, matterTypeApi, factoryApi, fstockApi } from "api/base.js";
import {
  purchaseType,
  sale,
  salereturn,
  salesOrder,
  queryOrder
} from "api/business.js";
import { company } from "api/system.js";

import vHead from "./components/order/head.vue";
import vList from "./components/order/list.vue";

import { mapState, mapActions } from "vuex";
export default {
  components: {
    vHead,
    vList
  },
  data() {
    return {
      checked: false,
		  num1: 0.00,
		  num2: 0.00,
      textarea: "",
      isLoading: true,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        details: [],
        page: 1, //当前页
        pageSize: 10, //每页显示的数量,
        searchCriteria: {}
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    // fromData:function(val,old){
    // 	console.log(val,old);
    // }
  },
  created() { 
    //请求初始数据
    this.id = this.$route.params.id;
    this.getInit();
    this.getStartData();
    this.registerEventListener();
  },
  methods: {
    /**
     * 注册事件监听
     */
    registerEventListener() {
      //点击tab页
      this.$bus.on("onClickTabPage", this.onClickTabPage);
      //移除tab页
      this.$bus.on("onRemoveTabPage", this.onRemoveTabPage);
    },
    //移除tab页
    onRemoveTabPage(tabName) {
      //this.$route.meta.clearCache=true;
      console.log("onRemoveTabPage clearCache=" + this.$route.meta.clearCache);
    },
    //点击tab页
    onClickTabPage(tabName) {
      //this.$route.meta.clearCache=false;
      console.log(" onClickTabPage clearCache=" + this.$route.meta.clearCache);
    },
    //获取初始数据
    async getInit() {
      let id = this.$route.params.id;
      //获取当前数据
      if (id) {
        //编辑
        let detail = await this.$get(queryOrder.find, { salesId: this.id });
        console.log(detail)
        if (detail.status) {
          this.isEdit = true;
          this.fromData = detail.data;
          this.$store.state.cache.selectedMatterSale = detail.data.details;
          this.fromData.postingDate = detail.data.createDate;
          this.fromData.saleVoucherNo = detail.data.saleVoucherNo;
          this.fromData.customerPurchCode = detail.data.saleVoucherNo;
        }
      }
    },
    ...mapActions("cache", ["clearCache"]),
    handleClick(tab, event) {},
    //关闭弹窗
    handleClose() {},
    //需要请求的初始数据
    async getStartData() {
      //客户
      if (!this.$store.state.cache.customerList) {
        let customerList = await this.$post(
          customerApi.list,
          this.$store.state.getAllPage
        );
        if (customerList.status) {
          console.log(customerList);
          customerList.data.list.forEach(item => {
            item.value = item.customerCode + "-" + item.customerName;
          });
          this.$store.state.cache.customerList = customerList.data.list;
        } else {
          this.$store.state.cache.customerList = null;
        }
      }
      //console.log(this.$store.state.cache.customerList,'==444==');
      //公司列表
      if (!this.$store.state.cache.companyList) {
        let companyList = await this.$post(
          company.list,
          this.$store.state.getAllPage
        );
        console.log(companyList, "==========");
        if (companyList.status) {
          companyList.data.list.forEach(item => {
            item.value = item.companyCode + "-" + item.companyName;
          });
          this.$store.state.cache.companyList = companyList.data.list;
          console.log(this.$store.state.cache.companyList, "====------====");
        } else {
          this.$store.state.cache.companyList = null;
        }
      }

      //客户采购订单编号
      if (!this.$store.state.cache.customerPurchCode) {
        let customerPurchCode = await this.$post(
          customerApi.list,
          this.$store.state.getAllPage
        );
        if (customerPurchCode.status) {
          customerPurchCode.data.list.forEach(item => {
            item.value = item.customerCode + "-" + item.customerName;
          });
          this.$store.state.cache.customerPurchCode =
            customerPurchCode.data.list;
        } else {
          this.$store.state.cache.customerPurchCode = null;
        }
      }

      this.isLoading = false;
    },
    handleChange(value) {
        console.log(value);
    },
    //保存提交数据
    subSave() {
      //console.log(this.fromData,"======== 测试表头数据 ========")
      let vm = this;
      if (!this.$store.state.cache.selectedMatterSale.length) {
        this.$message.error("请选择物料明细");
        return false;
      }
      this.fromData.details = [];
      let isTrue = true;
      this.$store.state.cache.selectedMatterSale.forEach(item => {
        let taxm1 = parseFloat(item.taxm1);
        let taxm1Str = taxm1.toString();
        item.taxm1 = taxm1.toFixed(2);
        if (taxm1 < 0 || taxm1 >= 100 || taxm1Str === "NaN") {
          vm.$message.error("销项税必须大于等于0或小于100之间");
          isTrue = false;
          return false;
        }
        if (!item.targetNum) {
          vm.$message.error("请输入销售数量");
          isTrue = false;
          return false;
        }
        if (!item.netPrice) {
          vm.$message.error("请输入销售价格");
          isTrue = false;
          return false;
        }
      });
      if (!isTrue) return false;

      let id = this.$route.params.id;
      var postUrl = salesOrder.add;
      if (id) postUrl = salesOrder.edit;

      this.fromData.details = this.$store.state.cache.selectedMatterSale;
      this.fromData.details.forEach(item => {
        item.targetUnitId = item.basicUnitId;
        if (id > 0) item.targetUnit = item.basicUnit;
        else item.targetUnit = item.basicUnitCode;
        item.targetUnitDesc = item.basicUnitDesc;
      });
      console.log(this.fromData.details, "11111111111");
      this.fromData.voucherDate = this.$moment(
        this.fromData.voucherDate
      ).format("YYYY-MM-DD");
      this.fromData.postingDate = this.$moment(
        this.fromData.postingDate
      ).format("YYYY-MM-DD");

      this.$confirm("确定提交数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.isLoading = true;
          this.loadingBg = "rgba(255,255,255,0.5)";
          this.loadingTxt = "数据处理中...";
          let res = await this.$post(postUrl, this.fromData);
          let json = JSON.stringify(this.fromData);
          console.log(json);
          this.isLoading = false;
          console.log(res);
          if (res.status) {
            let successMsg = id
              ? "物料" +
                res.data.details[0].saleVoucherNo +
                "修改成功。是否继续修改新的销售订单？"
              : "销售订单单号" +
                res.data.saleVoucherNo +
                "创建成功，是否继续？";
            this.$confirm(successMsg, "提示", {
              confirmButtonText: "继续",
              cancelButtonText: "退出",
              type: "success"
            })
              .then(() => {
                //凭证和过账默认今天
                let nowData = new Date();
                this.fromData = {
                  voucherDate: nowData,
                  postingDate: nowData,
                  details: []
                };
                this.noFromData = {};
                vm.$store.state.cache.selectedMatterSale = [];
                // vm.$router.push({ name: "business-sale-orderList" });
                vm.$keepAliveManager.backSourceRoute(this, {
                  name: "business-sale-orderList"
                });
                //清除部分缓存数据
                vm.clearCache();
              })
              .catch(() => {
                //凭证和过账默认今天
                let nowData = new Date();
                this.fromData = {
                  voucherDate: nowData,
                  postingDate: nowData,
                  details: []
                };
                this.noFromData = {};
                vm.$store.state.cache.selectedMatterSale = [];
                vm.$router.push({ name: "business-sale-order" });
                //清除部分缓存数据
                vm.clearCache();
              });
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.$message.success("已取消提交数据");
        });
    }
  }
};
</script>

<style lang="stylus" scoped></style>
